import type { ReactNode } from 'react';
import SharePreviewDownloadButton from 'components/ShareDocument/SharePreviewContent/SharePreviewDownloadButton';
import { hex_is_light } from 'components/Reports/ui/ReportDesignButton';
import { useLocation } from 'react-router';
import useLogoUrlReplacement from 'components/Dashboard/UserContent/ui/useLogoUrlReplacement';

interface SharePreviewToolbarProps {
  url: string;
  filename?: string;
  /** Organisation logo shown at the start of the bar. */
  logo?: string;
  /** Extra controls (PDF zoom / pagination) rendered before the download button. */
  left?: ReactNode;
  right?: ReactNode;
  /** Overrides the default grey bar background; falls back to `bg-grey` when unset. */
  barBackgroundColor?: string;
}

const SharePreviewToolbar = ({ url, filename, logo, left, right, barBackgroundColor }: SharePreviewToolbarProps) => {
  const filenameColor = hex_is_light(barBackgroundColor) ? '#00122b' : ' #fff';
  const location = useLocation();
  const shareDocumentPage = location?.pathname?.includes('share-document-v2');
  const { clientLogoReplacement } = useLogoUrlReplacement();
  const logoUrl = clientLogoReplacement({ organisationLogo: logo });

  return (
    <div className={`share-preview-controls ${shareDocumentPage ? '' : 'pt-5 bg-grey'} `}>
      <div
        className={`px-3 px-lg-5 specific-y-padding-12 overflow-auto share-preview-controls-container border-bottom ${shareDocumentPage ? '' : 'rounded-top'}`}
        style={barBackgroundColor ? { backgroundColor: barBackgroundColor } : undefined}
      >
        <div className='main-content-wrapper d-flex align-items-center mx-auto '>
          <div
            className='d-flex align-items-center share-preview-controls-identity w-100'
            style={{ minWidth: '180px' }}
          >
            <div className='share-preview-controls-logo'>
              {logo && (
                <img
                  src={logoUrl}
                  alt='Organisation logo'
                  className='rounded bg-white flex-shrink-0 mr-2'
                  style={{ width: '28px', height: '28px', objectFit: 'contain' }}
                />
              )}
            </div>
            <div className='flex-grow-1 flex-lg-grow-0 flex-centered  share-preview-filename-container justify-content-between'>
              {filename && (
                <span className='d-none d-lg-inline-block paragraph-p2 text-truncate' style={{ color: filenameColor }}>
                  {filename}
                </span>
              )}
              <div
                className='flex-grow-1 flex-lg-grow-0 flex-centered justify-content-between justify-content-lg-start ml-auto pl-3 flex-shrink-0'
                style={{ gap: '10px' }}
              >
                {left}
                {right}
                <SharePreviewDownloadButton url={url} filename={filename} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SharePreviewToolbar;
